<h3 class="text-center" *ngIf="showHeadings">Næste trækning finder sted om</h3>
<div  [ngClass]="{'mt-4 mb-4': !useAlternate}">
    <countdown [countdownDate]="t" #countdown (timerDone)="timeIsUp()" [showAllCountdownBlocks]="showAllCountdownBlocks" [useAlternate]="useAlternate" [makeFlex]="makeFlex" [yellowTiles]="yellowTiles"></countdown>
</div>
<h5 class="text-center" *ngIf="showHeadings">Og hvem ved – måske bliver det dig, der vinder. Held og lykke!</h5>
